import * as Yup from 'yup';

export default Yup.object().shape({
  cfdiUsage: Yup.string().required(
    'CLIENTS_VIEW.BILLING_DETAIL.CFDI_USAGE_REQUIRED'
  )
});
